import * as React from 'react';

import {gameGuideComponent, GameGuideComponentConfigurationContext} from './gameGuideComponentConfiguration';

const withGameGuideComponentConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <GameGuideComponentConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...gameGuideComponent}/>
                );
            }}
        </GameGuideComponentConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withGameGuideComponentConfiguration;